export default __webpack_public_path__ + "static/LogoColorless-55dd85325be61e48cc3bed467c32b419.png";